import { createSlice } from '@reduxjs/toolkit';

export const departamentSlice = createSlice({
    name: 'departaments',
    initialState: {
            departaments_list: [],
            departaments_list_select: []
    },
    reducers: {
        setDepartamentsRedux: ( state, { payload } ) => {
            state.departaments_list_select  =  payload;
        },
        setDepartamentsByIdRedux: ( state, departament_id ) => {
            const a  = state.departaments_list.filter( (departament:any) => departament.country_id == departament_id  );
            console.log(a)
            // state.departaments_list
        },
        setDepartamentSelectRedux: ( state, { payload } ) => {
            state.departaments_list_select  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setDepartamentsRedux, setDepartamentsByIdRedux, setDepartamentSelectRedux } = departamentSlice.actions;